import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { useLang } from "../context/LangContext";
import { Seo } from "../components/Seo";
import { Reveal, Hairline } from "../components/motion";
import { MEDIA, waLink } from "../lib/site";

const ServiceHero = ({ p }) => (
  <section className="relative pt-28 pb-14 md:pt-40 md:pb-20 overflow-hidden">
    <div className="absolute inset-0 z-0 bg-ink">
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 82% 20%, rgba(196,165,116,0.16), transparent 60%)" }} />
      <div className="absolute right-0 inset-y-0 w-1/2 hidden md:block">
        <img src={MEDIA.madeira} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-[0.10]" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/70 to-transparent" />
      </div>
    </div>
    <div className="container-lux relative z-10 max-w-4xl">
      <Reveal><div className="overline mb-8">{p.overline}</div></Reveal>
      <Reveal delay={0.1}>
        <h1 className="font-serif text-5xl md:text-7xl font-light leading-[1.05] text-cream">{p.h1}</h1>
      </Reveal>
      <Hairline className="my-10 max-w-xs" delay={0.3} />
      <Reveal delay={0.2}><p className="text-sand text-xl md:text-2xl font-light leading-relaxed max-w-3xl">{p.intro}</p></Reveal>
    </div>
  </section>
);

const ServiceBody = ({ p, lang }) => (
  <section className="pb-16 md:pb-24 bg-ink">
    <div className="container-lux grid lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-7 space-y-8">
        {p.paras.map((para, i) => (
          <Reveal key={para.slice(0, 40)} delay={i * 0.08}><p className="text-sand text-lg leading-relaxed font-light">{para}</p></Reveal>
        ))}
      </div>
      <div className="lg:col-span-5">
        <Reveal delay={0.15}>
          <div className="p-8 md:p-10 bg-ink-800 border border-gold/15">
            <div className="label-caps mb-6">{lang === "pt" ? "Inclui" : "Includes"}</div>
            <ul className="space-y-4">
              {p.bullets.map((b) => (
                <li key={b.slice(0, 40)} className="flex items-start gap-3 text-cream text-sm leading-relaxed">
                  <Check size={16} className="text-gold shrink-0 mt-0.5" strokeWidth={1.5} /> {b}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

const ServiceCta = ({ p, t, lang, path }) => (
  <section className="py-14 md:py-20 bg-ink-800 border-t border-gold/10">
    <div className="container-lux text-center flex flex-col items-center">
      <Reveal><h2 className="font-serif text-3xl md:text-4xl font-light text-cream max-w-2xl">{p.cta}</h2></Reveal>
      <Reveal delay={0.1}>
        <div className="flex flex-wrap gap-4 justify-center mt-10">
          <a href={waLink(lang)} target="_blank" rel="noreferrer" data-testid="inner-whatsapp" className="btn-solid btn-caps">{t.common.whatsapp}</a>
          <Link to={`${path("home")}#contact`} data-testid="inner-contact" className="btn-gold btn-caps">{t.common.book}</Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default function InnerService({ pageKey, dataKey }) {
  const { lang, t, path } = useLang();
  const p = t.pages[dataKey];

  return (
    <>
      <Seo title={p.metaTitle} description={p.metaDesc} pageKey={pageKey} />
      <ServiceHero p={p} />
      <ServiceBody p={p} lang={lang} />
      <ServiceCta p={p} t={t} lang={lang} path={path} />
    </>
  );
}
